import React from 'react';
import AssetCategories from '../../components/databaseConfig/assetCategories/AssetCategories';
import AssetOtherData from '../../components/databaseConfig/assetOtherData/AssetOtherData';
import { Department } from '../../components/databaseConfig/department/Department';
import Users from '../../components/databaseConfig/users/Users';
import BrandList from '../../components/databaseConfig/brandList/BrandList';
// import List from '../../components/table/Table';
import "./databaseConfig.scss";
import AllRoles from '../../components/databaseConfig/allRoles/AllRoles';

const DatabaseConfig = ({ component }) => {
    let ComponentToRender;

    switch (component) {
        case "department":
            ComponentToRender = <Department />;
            break;
        case "assetCategories":
            ComponentToRender = <AssetCategories />;
            break;
        case "users":
            ComponentToRender = <Users />;
            break;
        case "otherAssetContition":
            ComponentToRender = <AssetOtherData component="assetConditon" />;
            break;
        case "otherAssetEmployeeList":
            ComponentToRender = <AssetOtherData component="employeeList" />;
            break;
        case "otherAssetsCities":
            ComponentToRender = <AssetOtherData component="otherAssetsCities" />;
            break;
        case "brandList":
            ComponentToRender = <BrandList />;
            break;
        case "allRoles":
            ComponentToRender = <AllRoles />;
            break;
        default:
            ComponentToRender = <Department />;
            break;
    }

    return (
        <div className='dataBaseConfig'>
            <div className="dataBaseConfigContainer">
                {ComponentToRender}
            </div>
        </div>
    );
};

export default DatabaseConfig;
